module.exports = __webpack_public_path__ + "img/product-chuti-qt-03.f069903c.png";